package anjuros.development.modules

import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb

enum class Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#00A78E", rgb = rgb(r = 29, g = 54, b = 92)),
    OpacityPrimary(hex = "#00A78E", rgb = argb(a=0.2f,r = 29, g = 54, b = 92)),
    OpacityPrimary2(hex = "#00A78E", rgb = argb(a=0.8f,r = 29, g = 54, b = 92)),
    Secondary(hex = "#121D34", rgb = rgb(r = 18, g = 29, b = 52)),
    Gray(hex = "#CFCFCF", rgb = rgb(r = 207, g = 207, b = 207)),
    LightGray(hex = "#EDEDED", rgb = rgb(r = 237, g = 237, b = 237)),
    LighterGray(hex = "#F9F9F9", rgb = rgb(r = 249, g = 249, b = 249)),
    DarkGrey(hex = "#F9F9F9", rgb = rgb(r = 36, g = 37, b = 43)),
    FacebookColor(hex = "#1877F2", rgb = rgb(r = 24, g = 119, b = 242)),
    InstagramColor(hex = "#ee2a7b", rgb = rgb(r = 238, g = 42, b = 123))
}